/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { JsonNode } from './JsonNode';
import type { QuizConfig } from './QuizConfig';
export type StepRequest = {
    moduleId: string;
    agentId?: string;
    type: StepRequest.type;
    title: string;
    videoUrl?: string;
    durationMinutes?: number;
    description?: string;
    transcription?: string;
    quizConfig?: QuizConfig;
    orderPosition: number;
    metadata?: Record<string, Record<string, any>>;
    optional?: boolean;
    mindmap?: JsonNode;
};
export namespace StepRequest {
    export enum type {
        VIDEO = 'VIDEO',
        QUIZ = 'QUIZ',
    }
}

